import React from "react";
import "./ThreeDPieChart.scss";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);
am4core.addLicense("ch-custom-attribution");


class ThreeDPieChart extends React.Component{
    componentDidMount() {
        let chart = am4core.create("chartdiv", am4charts.PieChart3D);
        chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
        chart.legend = new am4charts.Legend();


        chart.data = this.props.chart_data;
	    chart.padding(0, 4, 0, 4);
	    chart.depth = 12;

        let series = chart.series.push(new am4charts.PieSeries3D());
        series.dataFields.value = "percent";
        series.dataFields.category = "title";
        series.ticks.template.events.on("ready", this.hideSmall);
        series.labels.template.events.on("ready", this.hideSmall);
        // chart.legend.position = "right";
        chart.legend.disabled=true;
        series.tooltip.disabled = true;



        // chart.legend.labels.template.fill="#fff";

        this.props.chart_data.map((item,index)=>{
            series.colors.list[index] =  am4core.color(item.color);
        })

        // series.colors.list = [
        //     am4core.color("#0AC09E"),
        //     am4core.color("#FF5C5C"),
        //     am4core.color("#F1C144"),
        // ];
        chart.background.fill = '#242426';


        this.chart = chart;
    }

    hideSmall = (ev) => {
        ev.target.hide();
    }

    componentWillUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    }

    render() {
        return(
            <div className="d-flex  pie-chart-component justify-content-between align-items-center">
                <div id="chartdiv" style={{width:" 165px"}}/>
                <div className={"chart-description-section"}>
                    {
                        this.props.chart_data.map((item,index)=>{
                            let total_length = this.props.chart_data.length;
                            return(
                                <>
                                <div className=" chart-description d-flex justify-content-between align-items-center" key={index}>
                                    <div className={"d-flex justify-content-between align-items-center"}>
                                        <div className="chart-data-box buy" style={{backgroundColor:item.color}}/>
                                        <div className="chart-label-text ">{item.title}</div>
                                    </div>
                                    <div className="chart-label-value ">{item.percent}%</div>
                                </div>
                                    {
                                        total_length === index + 1 ? null:<div className={"divider"}/>
                                    }

                                </>
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}

export default ThreeDPieChart;